module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_9.0c382345.mp3";